import { useQuery } from '@tanstack/react-query';
import { TimesheetConfigurationModelParsed } from './types';
import { QUERY_KEY_SETTINGS_TIMESHEET_BASIC, SETTINGS_QUERY_ALWAYS_REVALIDATE } from '@/lib/api/constants'
import { basicConfigurationMock } from './mock';
import { COMPANY_API_SETTINGS_MOCKED } from '@/env';
import { getTimesheetBasicSettings } from './getTimesheetBasicSettings';
import { parseTimesheetBasicSettings } from './parseTimesheetBasicSettings';

/**
 * Fetches basic timesheet company settings.
 */
export function useQueryTimesheetBasicSettings(companyId: string) {
  return useQuery<TimesheetConfigurationModelParsed>({
    queryKey: [QUERY_KEY_SETTINGS_TIMESHEET_BASIC, companyId],
    queryFn: async () => {
      if(COMPANY_API_SETTINGS_MOCKED){
        return basicConfigurationMock
      }
      const { data } = await getTimesheetBasicSettings({ companyId })
      return parseTimesheetBasicSettings(data);
    },
    enabled: !!companyId,
    ...SETTINGS_QUERY_ALWAYS_REVALIDATE,
  });
}
